import React from 'react';
import { useRoutes, RouteObject } from 'react-router-dom';
import {
    Routes as AppRoutes,
    DashboardPaths,
    FindShiftsPaths,
    LocationEligibilityPaths
} from '@amzn/atoz-shiftapp-initializer';
import {
    DashboardPage,
    FindShiftsPage,
    SchedulePage,
    SwapPage,
    LocationEligibilityPage
} from '@amzn/atoz-shiftapp-features';
import { MissingRoute } from '../MissingRoute';

const DashboardRoutes: RouteObject[] = DashboardPaths.map((path) => ({
    path,
    element: <DashboardPage />
}));
const FindShiftsRoutes: RouteObject[] = FindShiftsPaths.map((path) => ({
    path,
    element: <FindShiftsPage />
}));
const LocationEligibilityRoutes: RouteObject[] = LocationEligibilityPaths.map(
    (path) => ({
        path,
        // TODO: replace with real location eligibility page component
        element: <LocationEligibilityPage />
    })
);

export const App: React.FC = () => {
    return useRoutes([
        ...DashboardRoutes,
        ...FindShiftsRoutes,
        ...LocationEligibilityRoutes,
        {
            path: AppRoutes.MySchedule,
            element: <SchedulePage />
        },
        {
            path: AppRoutes.MyScheduleTimecard,
            element: <SchedulePage />
        },
        {
            path: AppRoutes.Swap,
            element: <SwapPage />
        },
        {
            path: '*',
            element: <MissingRoute />
        }
    ]);
};
